import moment from 'moment'
import momentTimezone from 'moment-timezone'

export const convertNumberToDate = (millisec) => {
  return millisec ? moment(millisec).format('DD/MMM/YY h:mm A') : ''
};

export const convertDateToString = (date) => (format) => moment(date).format(format)
export const convertStringToDate = (dateTime, format) => moment(dateTime, format).toDate()
export const convertDateToStringWithTimeZone = (date, timezone = 'Asia/Bangkok') => (format) => momentTimezone.tz(date, timezone).format(format)
export const getDateWithTimezone = (timezone = 'Asia/Bangkok') => momentTimezone.tz(new Date(), timezone).toDate()
export const getDateString = (date, timezone = 'Asia/Bangkok') => ((date && date !== '') ? date : momentTimezone.tz(new Date(), timezone).format('YYYY-MM-DD'))



// WEBPACK FOOTER //
// ./src/helpers/timeHelpers.js